import {useNavigate, useSearchParams} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "../../lib/AppContext";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import {getReportData, getReportDefinition} from "../common/api/ReportApi";
import {CardContent} from "@mui/material";
import Loading from "../common/Loading";
import Icon from "@mui/material/Icon";
import Checkbox from "@mui/material/Checkbox";
import {BarChart} from "@mui/x-charts/BarChart";
import MDButton from "../../components/MDButton";
import {formatDate} from "../common/Utils";

export default function CheckinReportGraph({
                                             type,
                                             defaultDate,
                                             defaultRangeStart
                                           }) {

  const widthFn = () => {
    return parseInt(window.innerWidth, 10) * .75;
  }
  const [docWidth, setDocWidth] = useState(100);

  useEffect(() => {
    function handleWidthFn() {
      setDocWidth(widthFn());
    }

    window.addEventListener("resize", handleWidthFn);
    handleWidthFn();
    return () => window.removeEventListener("resize", handleWidthFn);
  }, []);

  const [loading, setLoading] = useState(false);
  const [reportName, setReportName] = useState('');
  const [context, setContext] = useContext(AppContext);
  const navigate = useNavigate();

  const [reportPeriod, setReportPeriod] = useState();
  const [reportData, setReportData] = useState();

  const [eventDate, setEventDate] = useState();
  useEffect(()=>{
    setEventDate(defaultDate);
  },[defaultDate]);

  const [eventEndDate, setEventEndDate] = useState();
  const [reportDefinition, setReportDefinition] = useState(null);

  useEffect(() => {
    if (!eventDate) {
      return;
    }
    getReportDataFn(false);
  }, [eventDate])

  const [chartData, setChartData] = useState();

  const formatChartData = (report) => {
    if (report?.pieChartData) {
      setChartData(report?.pieChartData);
    }
  }

  const [initLoad, setInitLoad] = useState(false);

  const getReportDataFn = (firstLoad) => {

    if (!eventDate) {
      return;
    }
    let req = {
      startDate: eventDate,
      all: false
    }

    getReportData(type, req).then((r) => {
      setReportData(r);
      formatChartData(r);
      setInitLoad(true);
      setLoading(false);
    });
  }

  const refreshReservations = () => {
    setLoading(true);
    getReportDataFn(false);
  }


  const ActionCheckbox = React.forwardRef(({row, onClick}, ref) => {
    return (
      <>
        <div className="form-check mt-1" style={{backgroundColor: ''}}>
          {row && <Checkbox
            type="checkbox"
            style={{height: '20px', width: '20px'}}
            ref={ref}
            onClick={() => {
              row.selected = !row.selected;
            }}
          />}
        </div>
      </>
    )
  })


  useEffect(() => {
      getReportDefinition(type).then((r) => {
        setReportName(r.name);
        let _def = {...r};
        setReportDefinition(_def);
        return;
      });
    }, []
  );

  const [searchParams, setSearchParams] = useSearchParams();

  const [render, setRender] = useState(1);


  return (

    <MDBox>
      <MDBox>
        {(!reportData) && <Loading/>}
        {reportData && <Grid container spacing={1} mb={2}>
          {loading &&
            <Grid item sm={12} xs={12}>
              <Card>
                <MDBox pt={1}>
                  <CardContent sx={{
                    height: '160px',
                    width: '100%'
                  }}>
                    <h5>
                      Hourly Check-Ins
                      &nbsp;
                    </h5>
                    <center><Loading/></center>
                  </CardContent>
                </MDBox>
              </Card>
            </Grid>
          }
          {!loading && <>
            {reportDefinition?.chartData &&
              <>{chartData && <Grid item sm={12} xs={12}>
                <Card>
                  <MDBox pt={1}>
                    <CardContent sx={{
                      height: chartData?.length === 0 ? '160px' : '340px'
                    }}>
                      <h5>
                        Hourly Check-Ins
                        &nbsp;
                        <MDButton
                          onClick={() => {
                            refreshReservations()
                          }}
                          color="primary"
                          variant="outlined"
                          className={'pull-right'} circular={true} iconOnly={true}>
                          <Icon>refresh</Icon>
                        </MDButton>
                      </h5>
                      {chartData && <BarChart
                        slotProps={{
                          noDataOverlay: {
                            message: `No check-ins for ${formatDate(eventDate, 'MM/DD/YYYY')}`,
                          },
                        }}
                        tooltip={{trigger: 'item'}}
                        grid={{vertical: true, horizontal: true}}
                        dataset={chartData}
                        xAxis={[
                          {
                            scaleType: 'band',
                            dataKey: 'label',
                            colorMap: {
                              type: 'ordinal',
                              colors: ['#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#08589e']
                            }
                          }
                        ]}
                        series={[{dataKey: 'value'}]}
                        width={docWidth}
                        height={chartData?.length === 0 ? 120 : 300}
                      />}
                    </CardContent>
                  </MDBox>
                </Card>

              </Grid>}
              </>
            }
          </>
          }
        </Grid>
        }
      </MDBox>
    </MDBox>
  );
}